import { useEffect, useState } from 'react';

import { useConfigContext } from 'lib/core/config';
import { useAuthContext } from 'lib/core/context/AuthProvider';

import getInstanceDirectories from 'lib/common/api/getInstanceDirectories';
import getInstanceQueues from 'lib/common/api/getInstanceQueues';
import IQueue from 'lib/common/types/InstanceQueue';
import filterDisabledQueues from 'lib/common/utils/filterDisabledQueues';
import { applyQueueWhitelistToQueues } from 'lib/common/utils/queues/applyQueueWhitelistToQueues';
import { getQueueConfig } from 'lib/common/utils/queues/getQueueConfig';

import Context from './Context';

function InstanceProvider({ children }) {
  const { fetch_ } = useAuthContext();
  const { config } = useConfigContext();

  const [instanceQueues, setInstanceQueues] = useState<IQueue[]>([]);
  const [allVisibleQueues, setAllVisibleQueues] = useState<IQueue[]>([]);
  const [instanceDirectories, setInstanceDirectories] = useState({});

  const setQueueInformation = async () => {
    const response = await getInstanceQueues({ fetch_, config });
    const { queueWhitelist } = getQueueConfig(config);
    const filteredOutHiddenQueues = filterDisabledQueues({
      allQueues: response,
      disabledQueuePrefix: config.DISABLED_QUEUE_PREFIX,
    });

    const queuesWithWhitelistApplied = applyQueueWhitelistToQueues({
      queues: filteredOutHiddenQueues,
      queueWhitelist,
    });

    setAllVisibleQueues(filteredOutHiddenQueues);
    setInstanceQueues(queuesWithWhitelistApplied);
  };

  const setDirectories = async () => {
    const response = await getInstanceDirectories({ fetch_, config });
    setInstanceDirectories(response);
  };

  useEffect(() => {
    setQueueInformation();
    setDirectories();
  }, []);

  return (
    <Context.Provider
      value={{
        instanceQueues,
        instanceDirectories,
        allVisibleQueues,
      }}
    >
      {children}
    </Context.Provider>
  );
}

export default InstanceProvider;
